import axios from "axios";
import server from "@/utils/server";
const actions = {
  // 搜索结果的
  // 获取订单列表
  SearchAuto({ context }, data) {
    return new Promise((reslove, reject) => {
      server
        .myAxios("/api/SearchAuto/SearchAutoV2", data, {
          ignoreLoading: true,
        })
        .then((res) => {
          reslove(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  // 通过品类组下面的品类的id集合 去获取对应的品类下面的配件
  GetCjmlAutoValidPartAndParam({ context }, data) {
    return new Promise((reslove, reject) => {
      server
        .myAxios("/api/SearchAuto/GetCjmlAutoValidPartAndParam", data, {
          ignoreLoading: true,
        })
        .then((res) => {
          reslove(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  // 获取扫码记录
  GetVinSearchLogs({ context }) {
    return new Promise((reslove, reject) => {
      server
        .myAxios("/api/SearchAuto/GetVinSearchLogs", undefined, {
          ignoreLoading: true,
        })
        .then((res) => {
          reslove(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  // 取得商品详情
  GetPartItemDetail({ context }, data) {
    return new Promise((reslove, reject) => {
      server
        .myAxios("/api/SearchAuto/GetPartItemDetail", data)
        .then((res) => {
          reslove(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  // // 取得技术参数
  GetAutoPartsConfigAll({ context }, data) {
    return new Promise((reslove, reject) => {
      server
        .myAxios("/api/SearchAuto/GetAutoPartsConfigAll", data)
        .then((res) => {
          reslove(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  // // 取得新技包的文章
  GetTechInstructInfo({ context }, data) {
    return new Promise((reslove, reject) => {
      server
        .myAxios("/api/SearchAuto/GetTechInstructInfo", data)
        .then((res) => {
          reslove(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  // // 检查vin码Byvin码Code
  CheckVinByVinCode({ context }, data) {
    return new Promise((reslove, reject) => {
      server
        .myAxios("/api/SearchAuto/CheckVinByVinCode", data, {
          ignoreLoading: true,
        })
        .then((res) => {
          reslove(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  // // 检查vin码By文件流
  CheckVinByFile({ context }, data) {
    return new Promise((reslove, reject) => {
      server
        .myAxios("/api/SearchAuto/CheckVinByFile", data, {
          ignoreLoading: true,
        })
        .then((res) => {
          reslove(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  // GetVinShareStatistics({
  //     context
  // }) {
  //     return new Promise((reslove, reject) => {
  //         server.myAxios("/api/UserCenter/GetVinShareStatistics", undefined, {
  //             ignoreLoading: true
  //         }).then(res => {
  //             reslove(res)
  //         }).catch(err => {
  //             reject(err)
  //         })
  //     })
  // },
};

export default {
  namespaced: true,
  actions,
};
